import { Flex, Text, Tooltip } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreItem } from '@flecto/types'
import {
  AvatarItem,
  BadgeItemStatus,
  BadgeItemStatusStore,
  TextCurrency,
  TextItemCategory,
  type DataTableColumn,
} from '@flecto/ui'

import { TextItemPrice } from '../TextItemPrice/TextItemPrice'

export const useColumns = () => {
  const { t } = useTranslation('saas', { keyPrefix: 'items' })

  const columns: DataTableColumn<CoreItem>[] = [
    {
      accessor: 'id',
      title: 'ID',
      width: 70,
      render: (row) => <Text c='dimmed'>{row.internal_id}</Text>,
    },
    {
      accessor: 'title',
      title: t('label_product'),
      width: 250,
      render: (row) => (
        <Flex style={{ overflow: 'hidden' }} gap='md' align='center'>
          <AvatarItem item={row} />
          <Tooltip label={row.title}>
            <Text fw={500} truncate>
              {row.title}
            </Text>
          </Tooltip>
        </Flex>
      ),
    },
    {
      accessor: 'status',
      title: t('label_status'),
      width: 120,
      render: (row) => <BadgeItemStatus item={row} />,
    },
    {
      accessor: 'category',
      title: t('label_category'),
      width: 280,
      render: (row) => {
        const text = (
          <TextItemCategory
            categoryId={row.category_id ?? ''}
            withBreadcrumbNames
          />
        )

        return (
          <Tooltip label={text}>
            <Text c='dimmed' truncate>
              {text}
            </Text>
          </Tooltip>
        )
      },
    },
    {
      accessor: 'quantity',
      title: t('label_quantity'),
      width: 80,
      render: (row) => (row.track_quantity ? row.quantity : '∞'),
    },
    {
      accessor: 'price_cents',
      title: t('label_price_per_unit'),
      width: 170,
      render: (row) => <TextItemPrice item={row} />,
    },
    {
      accessor: 'deposit_cents',
      title: t('label_deposit'),
      width: 150,
      render: (row) => <TextCurrency cents={row.deposit_amount} />,
    },
    {
      accessor: 'on_store',
      title: t('label_on_store'),
      width: 120,
      render: (row) => <BadgeItemStatusStore item={row} />,
    },
  ]

  return columns
}
